<template>
    <PublicTemplate>
        <section class="PageHero__HeroStyle-bmq1vi-0 gLYwgj white">
            <div class="container">
                <div class="animated fadeInUp" style="animation-duration: 1s;">
                    <h4 class="section_subtitle" _msttexthash="92547" _msthash="31">CMECH BLOG</h4>
                    <h1 class="section_title" _msttexthash="8552414" _msthash="32">Câu chuyện mới nhất của chúng tôi
                    </h1>
                    <p class="content_center section_description" _msttexthash="1068201966" _msthash="33">Các chuyên gia
                        hàng đầu của ngành công nghiệp phần cứng cửa và cửa sổ cung cấp các thiết kế, nghiên cứu và hiểu
                        biết tốt nhất của họ. Kết hợp các giải pháp bền vững và công nghệ tòa nhà thông minh với xu
                        hướng nội thất hiện đại, blog của CMECH là hướng dẫn hoàn hảo để tạo ra văn phòng cao cấp, nhà ở
                        sang trọng và đỉnh cao quản lý dự án xây dựng. Hướng dẫn lựa chọn cửa và cửa sổ toàn diện nhất
                        mà bạn từng tìm thấy.</p>
                </div>
            </div>
        </section>
        <section class="blog__BlogSectionPage-sc-1kdqt1v-0 hlpkNc">
            <div class="blog_content">
                <div class="animated fadeInUp" style="animation-duration: 1s;">
                    <div class="container">
                        <h5 _msttexthash="4533763" _msthash="34">Tất cả các câu chuyện</h5>
                        <div class="blog_content_grid">
                            <ul class="blog_list">
                                <li v-for="blog in list" :key="blog.link" class="blog_post">
                                    <router-link class="permalink" :to="blog.link">
                                        <div class="featured_image"><img :src="blog.background" :alt="blog.title"
                                                loading="lazy"></div>
                                    </router-link>
                                    <div class="blog_category"><a class="category_link">
                                            <p>{{ blog.parent.title }}</p>
                                        </a>
                                        <router-link class="blog_title" :to="blog.link">
                                            <h4>{{ blog.title }}</h4>
                                        </router-link>
                                    </div>
                                </li>
                            </ul>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    </PublicTemplate>
</template>

<script>
import PublicTemplate from '@/templates/PublicTemplate.vue';
const axios = require('axios').default;
export default {
    data() {
        return {
            list: []
        }
    },
    name: 'BlogView',
    async mounted() {
        try {
            let res = await axios.get("/api/blog.json");
            if (res) {
                this.list = res.data;
            }
        } catch {
            console;
        }
    },
    components: {
        PublicTemplate
    }
}
</script>

<style lang="less">
.hWBHX {
    background: var(--brand_black);
    opacity: 0;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    overflow: hidden;
}

/*!sc*/
.hWBHX.fade_in {
    opacity: 1;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper {
    padding-top: 40px;
    padding-bottom: 40px;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper {
        padding-top: 50px;
        padding-bottom: 15px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
    display: grid;
    grid-template-columns: 1fr 1fr;
    -webkit-column-gap: 90px;
    column-gap: 90px;
    -webkit-align-items: center;
    -webkit-box-align: center;
    -ms-flex-align: center;
    align-items: center;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
        grid-template-columns: 1fr;
    }
}

/*!sc*/
@media (max-width:480px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid {
        text-align: center;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
    margin-bottom: 55px;
    color: white;
    text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 {
        margin-bottom: 30px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
    height: 34px;
    margin-right: 15px;
    fill: white;
    padding-top: 6px;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text h2 svg {
        height: 26px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap {
    margin-bottom: 35px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .content_wrap p {
    color: #fff;
    text-align: left;
    margin-bottom: 15px;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
    display: block;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper {
        padding-bottom: 60px;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
    place-items: left;
    display: block;
    text-align: left;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper {
        place-items: center;
        text-align: center;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a {
    color: white;
    border: 1px solid white;
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_text .button_wrapper .link_wrapper a:hover {
    color: var(--brand_black);
    background-color: white;
    -webkit-transform: translateY(-3px);
    -ms-transform: translateY(-3px);
    transform: translateY(-3px);
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
    padding-top: 75%;
    display: block;
    -webkit-text-decoration: none;
    text-decoration: none;
    overflow: hidden;
    position: relative;
}

/*!sc*/
@media (max-width:1024px) {
    .hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image {
        display: none;
    }
}

/*!sc*/
.hWBHX .container_small .learn_how_grid_wrapper .learn_how_grid .learn_how_image img {
    height: 100%;
    display: block;
    position: absolute;
    object-fit: cover;
    object-position: center;
    top: 50%;
    left: 50%;
    -webkit-transform: translate(-50%, -50%);
    -ms-transform: translate(-50%, -50%);
    transform: translate(-50%, -50%);
}

/*!sc*/
data-styled.g5[id="LearnHow__LearnHowWrap-bgqo87-0"] {
    content: "hWBHX,"
}

/*!sc*/
.gLYwgj {
    margin-top: 140px;
    padding: 80px 0;
    min-height: 367px;
    -webkit-transition: var(--transition);
    transition: var(--transition);
    place-content: center;
    display: grid;
    overflow: hidden;
}

/*!sc*/
@media (max-width:1024px) {
    .gLYwgj {
        min-height: 300px;
        margin-top: 50px;
        padding: 60px 0;
    }
}

/*!sc*/
.gLYwgj.white {
    background-color: white;
}

/*!sc*/
.gLYwgj.grey {
    background-color: #f7f5f4;
}

/*!sc*/
.gLYwgj.fade_in {
    opacity: 1;
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.gLYwgj .section_description {
    margin: 0;
}

/*!sc*/
data-styled.g47[id="PageHero__HeroStyle-bmq1vi-0"] {
    content: "gLYwgj,"
}

/*!sc*/
.hlpkNc {
    -webkit-transition: var(--transition);
    transition: var(--transition);
}

/*!sc*/
.hlpkNc .blog_content {
    background: #f7f5f4;
    overflow: hidden;
}

/*!sc*/
.hlpkNc .blog_content .container {
    padding-top: 40px;
}

/*!sc*/
.hlpkNc .blog_content .container h5 {
    font-size: 0.6em;
    line-height: 1.1;
    color: var(--text_grey);
    text-transform: uppercase;
    font-weight: 500;
    margin: 0;
    margin-bottom: 40px;
    display: grid;
    grid-template-columns: auto 1fr;
    gap: 30px;
}

/*!sc*/
.hlpkNc .blog_content .container h5:before {
    -webkit-align-self: center;
    -ms-flex-item-align: center;
    align-self: center;
    content: ' ';
    display: block;
    width: 30px;
    height: 2px;
    background-color: var(--text_grey_light);
    opacity: 0.1;
}

/*!sc*/
data-styled.g65[id="blog__BlogSectionPage-sc-1kdqt1v-0"] {
    content: "hlpkNc,"
}

/*!sc*/
</style>